const notificationOptions = {
  DEFAULT: 'DEFAULT',
  SMS: 'SMS',
  FCM: 'FCM',
};

export default notificationOptions;
